<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <div class="row">
        <div class="col-12 col-md-6">
            <h1 class="title-default">Histórico de Notificações</h1>
        </div>
        <div class="col-12 col-md-6 d-flex justify-content-end align-items-center gap-3">
            <button mat-raised-button class="btn-primary" (click)="novaNotificacao()">
                <mat-icon>add</mat-icon>
                Nova Notificação
            </button>
        </div>
    </div>

    <form class="form search-area" [formGroup]="model" (ngSubmit)="clickPesquisar()">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field appearance="outline">
                    <mat-label>Título</mat-label>
                    <input matInput formControlName="titulo" type="text">
                </mat-form-field>
            </div>
            
            <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field appearance="outline">
                    <mat-label>Data Inicial</mat-label>
                    <input matInput [matDatepicker]="pickerIni" formControlName="dataInicio">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerIni"></mat-datepicker-toggle>
                    <mat-datepicker #pickerIni></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field appearance="outline">
                    <mat-label>Data Final</mat-label>
                    <input matInput [matDatepicker]="pickerFim" formControlName="dataFim">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerFim"></mat-datepicker-toggle>
                    <mat-datepicker #pickerFim></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-6 col-md-3">
                <button type="submit" mat-button class="btn-secundary" style="width: 100%; height: 56px;">
                    Pesquisar
                </button>
            </div>
        </div>
    </form>

    @if(_isLoading && _dataSource.data.length === 0){
        <div class="row mt-4">
             @for (item of [1,2,3]; track item) {
                <div class="col-12 mb-2">
                    <app-loading-box [height]="'40'" [width]="'100%'" [marginTop]="'10'"></app-loading-box>
                </div>
            }
        </div>
    }

    @if(_dataSource.data.length > 0){
        <table class="desktop-table" mat-table [dataSource]="_dataSource">
            
            <ng-container matColumnDef="idMensagem">
                <th mat-header-cell *matHeaderCellDef> # </th>
                <td mat-cell *matCellDef="let element"> {{element.idMensagem}} </td>
            </ng-container>

            <ng-container matColumnDef="titulo">
                <th mat-header-cell *matHeaderCellDef> Título </th>
                <td mat-cell *matCellDef="let element"> {{element.tituloMensagem}} </td>
            </ng-container>

            <ng-container matColumnDef="remetente">
                <th mat-header-cell *matHeaderCellDef class="col-responsiva"> Enviado Por </th>
                <td mat-cell *matCellDef="let element" class="col-responsiva"> 
                    {{ element.nomeRemetente || 'Carregando...' }} 
                </td>
            </ng-container>

            <ng-container matColumnDef="data">
                <th mat-header-cell *matHeaderCellDef class="col-responsiva"> Data Envio </th>
                <td mat-cell *matCellDef="let element" class="col-responsiva"> 
                    {{element.datetimeInclusao | date:'dd/MM/yyyy HH:mm'}} 
                </td>
            </ng-container>
            
            <ng-container matColumnDef="stats">
                <th mat-header-cell *matHeaderCellDef> Destinatários </th>
                <td mat-cell *matCellDef="let element"> 
                    <span matTooltip="Recebidos / Lidos">
                        {{element.quantidadeDestinatarios}} <small>({{element.quantidadeLidos}} lidos)</small>
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Status </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    @if(element.datetimeDelecao){
                        <span class="status-badge error" 
                            [matTooltip]="'Excluída em: ' + (element.datetimeDelecao | date:'dd/MM/yyyy')">
                            Excluída
                        </span>
                    } @else {
                        <span class="status-badge success">Enviada</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Ações </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    <div class="d-flex justify-content-end gap-2">
                        <a mat-mini-fab class="fab-action default" (click)="abrirDetalhes(element)" matTooltip="Ver Detalhes">
                            <mat-icon>visibility</mat-icon>
                        </a>
                        <a mat-mini-fab class="fab-action default" (click)="confirmarExclusao(element)" matTooltip="Excluir Notificação" [disabled]="element.datetimeDelecao">
                            <mat-icon>delete</mat-icon>
                        </a>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="mobile-cards">
            @for(element of _dataSource.data; track element.idMensagem){
                <div class="card">
                    <div class="card-header">
                        <div class="card-header-title">
                            {{element.tituloMensagem}}
                        </div>
                        <div>
                            @if(element.datetimeDelecao){
                                <span class="status-badge error">Excluída</span>
                            } @else {
                                <span class="status-badge success">Enviada</span>
                            }
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="card-row">
                            <span class="card-label">Data Envio</span>
                            <span class="card-value">{{element.datetimeInclusao | date:'dd/MM/yyyy HH:mm'}}</span>
                        </div>
                        <div class="card-row">
                            <span class="card-label">Enviado Por</span>
                            <span class="card-value">{{ element.nomeRemetente || '...' }}</span>
                        </div>
                        <div class="card-row">
                            <span class="card-label">Destinatários</span>
                            <span class="card-value">{{element.quantidadeDestinatarios}}</span>
                        </div>
                        <div class="card-row">
                            <span class="card-label">Lidos</span>
                            <span class="card-value">{{element.quantidadeLidos}}</span>
                        </div>
                    </div>
                    <div class="card-actions">
                         <button mat-mini-fab class="fab-action default" (click)="abrirDetalhes(element)">
                            <mat-icon>visibility</mat-icon>
                        </button>
                        @if(!element.datetimeDelecao){
                            <button mat-mini-fab class="fab-action default" (click)="confirmarExclusao(element)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        }
                    </div>
                </div>
            }
        </div>
        <div class="col-12 text-center ver-mais-pesquisa">
            <button type="button" mat-button class="btn-primary" [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                    Ver mais
                }
            </button>
        </div>

    } @else if(!_isLoading && _dataSource.data.length === 0) {
        <app-empty-list [title]="'Nenhuma notificação encontrada com os filtros informados'"></app-empty-list>
    }
</div>